export class Point {
    constructor(public latitude:number, public longitude:number, public altitude:number){};
}
